import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  @media screen and (max-width: 767px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  position: relative
  width: 100%;
  height: 100%;
  background-size: cover;
  display: flex;
  flex-direction: row;

  @media screen and (max-width: 767px) {
    border-radius: 0;
  }
`;

export const DescriptionWrapper = styled.div`
  width: 65%;
  padding-left: 140px;
  border: 1px solid transparent;

  @media screen and (max-width: 767px) {
    padding: 0 30px;
    text-align: center;
    width: 100%;
  }
`;

export const Title = styled.div`
  font-family: Poppins-Bold;
  font-size: 3.4vw;
  line-height: 135%;
  color: #000000;
  margin-top: 100px;
  z-index: 9;
  position: sticky;

  @media screen and (max-width: 767px) {
    font-size: 40px;
    margin-top: 35px;
  }
`;

export const Message = styled.div`
  color: #000000;
  font-size: 26px;
  line-height: 37px;
  font-family: Poppins-Regular;
  margin-top: 15px;
  margin-bottom: 30px;
`;

export const Action = styled.button`
  font-family: Poppins-Regular;
  padding: 15px 50px;
  background: #D40020;
  border: 1.70213px solid #D40020;
  border-radius: 30.72px;
  font-weight: 400;
  font-size: 18.7234px;
  line-height: 18px;
  text-align: center;
  color: #FFFFFF;
  margin-bottom: 65px;
  margin-top: 50px;
  cursor: pointer;
  z-index: 9;
  &:hover {
    opacity: 0.9;
  }

  @media screen and (max-width: 767px) {
    width: 70%;
    font-size: 15px;
  }
`;

export const DemonstratioWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  max-width: 35%;
  margin-top: 20px;

  position: absolute;
  top: -450px;
  right: 250px;

  @media screen and (max-width: 767px) {
    position: relative;
    max-width: 100%;
    border: 1px solid green;
  }
`;

export const DemonstrationImage = styled.img`
  width: 200%;
  z-index: 9;
`;

export const BlueContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(images/header/blue-bg.png);
  background-size: cover;
  display: flex;
  padding: 300px 50px 180px 100px;
  flex-direction: row;
  margin-top: 50px;

  @media screen and (max-width: 767px) {
    border-radius: 0;
    flex-direction: column;
    padding: 30px;
  }
`;

export const WhiteTitle = styled.div`
  font-family: IBMPlexSans;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 150%;
  color: #FFFFFF;
  margin-right: 70px;
  width: 50%;

  @media screen and (max-width: 767px) {
    text-align: center;
    width: 100%;
    font-size: 24px;
    padding: 20px;
  }
`;

export const LogoContainer = styled.div`
  border: 1px solid #fff;
  width: 25vh;
  height: 160px;
  border-radius: 9px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 50px;

  @media screen and (max-width: 767px) {
    width: 100px;
    height: 80px;
    margin-right: 0px;
    border-radius: 4.21542px;
  }
`;

export const LogoBB = styled.img`
  height: 40%;

  @media screen and (max-width: 767px) {
    height: 40%;
  }
`;

export const LogoSicredi = styled.img`
  height: 23%;

  @media screen and (max-width: 767px) {
    height: 40%;
  }
`;

export const LogoInfo = styled.img`
  width: 80%;

  @media screen and (max-width: 767px) {
    width: 90%;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  @media screen and (max-width: 767px) {
    margin-top: 40px;
    margin-bottom: 70px;
  }
`;

export const TypesDescriptionRow = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 12px;
`;

export const RowBreak = styled.div`
  flex-basis: 100%;
  height: 0;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const TypeItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
`;

export const TypeDescription = styled.span`
  color: #000;
  font-family: Poppins-Regular;
  font-size: 14.057px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const TypeImage = styled.img`
  width: 20.99px;
  height: 17.603px;
`;

export const StartButton = styled.button`
  border-radius: 99px;
  padding: 12px 32px;
  color: #FFF;
  font-family: Poppins-Regular;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  background: #D40020;
  border: 0px;
  cursor: pointer;
  margin-top: 50px;
`;
